<template>
  <b-container v-bind:class="{ 'mt-0' : isFanView}">
    <Headline title="Live Streams" v-if="!isFanView"></Headline>
    <ObjectListTabs v-if="!isFanView">
      <template slot-scope="{}">
        <b-nav-item :to="{name: 'artist-my-live-stream-list', params: { visibility: 'public'}}">Public Events</b-nav-item>
        <b-nav-item :to="{name: 'artist-my-live-stream-list', params: { visibility: 'private'}}">Private Events</b-nav-item>
        <b-nav-item :to="{name: 'artist-my-live-stream-list', params: { visibility: 'draft'}}">Drafts</b-nav-item>
        <b-nav-item :to="{name: 'artist-my-live-stream-list', params: { visibility: 'past'}}">Past/Cancelled Live Streams</b-nav-item>
      </template>
      <template slot="cmd" slot-scope="{}">
        <b-button class="btn-rainbow" :to="{name: 'artist-live-stream-create'}" size="sm">
          <font-awesome-icon icon="plus"/> create live stream
        </b-button>
      </template>
      <template slot="mobileCmd" slot-scope="{}">
        <b-nav-item :to="{name: 'artist-live-stream-create'}"><font-awesome-icon icon="plus"/> create live stream</b-nav-item>
      </template>
    </ObjectListTabs>

    <ProfileHero :artist="artist" v-if="isFanView && artist" />
    <ArtistProfileTabs :artist="artist" v-if="isFanView && artist" />

    <div class="future">
      <EventCard v-for="live in liveEvents" :key="live.id"
        :live="live"
        :withWatchlistButton="isFanView"
        :to="getEventRoute(live)" />
      </div>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 1em;
  }
  .future {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  @include media-breakpoint-up(md) {
    .future {
      justify-content: left;
    }
  }
</style>

<script>
import ObjectListTabs from '@/components/widgets/ObjectListTabs'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import EventCard from '@/components/widgets/EventCard'
import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'
import Headline from '@/components/widgets/Headline'

export default {
  name: 'LiveStreamList',
  components: {
    FontAwesomeIcon,
    ObjectListTabs,
    EventCard,
    ArtistProfileTabs,
    ProfileHero,
    Headline
  },
  data () {
    return {
      artist: null,
      liveEvents: []
    }
  },
  computed: {
    isFanView () {
      return !!this.$route.params.artistId
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      if (this.$route.params.artistId) {
        this.artist = await this.$store.dispatch('artist/getArtist', { id: this.$route.params.artistId })
        this.liveEvents = (await this.$store.dispatch('live/listLiveEvents', {
          artist_id: this.artist.id
        })).results
      } else {
        this.artist = this.$store.getters['artist/artist']
        this.liveEvents = (await this.$store.dispatch('live/listOwnLiveEvents', {
          visibility: this.$route.params.visibility
        })).results
      }
    },
    getEventRoute (live) {
      if (this.isFanView) {
        return {
          name: 'artist-live-stream-detail',
          params: {
            artistId: this.$route.params.artistId,
            liveId: live.id
          }
        }
      } else if (live.has_ended) {
        return {
          name: 'artist-live-stream-edit',
          params: {
            id: live.id
          }
        }
      } else {
        return {
          name: 'artist-live-stream',
          params: {
            id: live.id
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/LiveStreamList.vue